// constants/copyDataConstants.js

export const COPY_OPTIONS = [
  {
    id: 'ACCOUNT_STATUSES',
    label: 'Status codes associated with requirements, users etc',
    tableName: ['ACCOUNT_STATUSES', 'ACCOUNT_STATUS_DETAILS'],
    description: 'Account status configurations',
    mandatory: true
  },
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
    // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.

  {
    id: 'BUSINESS_TEAMS',
    label: 'Project team',
    tableName: 'BUSINESS_TEAMS',
    description: 'Team structure and assignments',
    mandatory: false
  },
    // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.

  {
    id: 'FUNCTIONAL_LEVELS',
    label: 'Functional hierarchy',
    tableName: 'FUNCTIONAL_LEVELS',
    description: 'Organizational hierarchy levels',
    mandatory: false
  },
    // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.
  // MAKE SURE TO CHANGE THE BACKEND API TO ADD SEQUENCE NUMBER GENERATION TABLE AS WELL IF NEEDED.

  {
    id: 'INTEGRATION_SYSTEMS',
    label: 'Full set of provider and consumer systems',
    tableName: 'INTEGRATION_SYSTEMS',
    description: 'System integration configurations',
    mandatory: false
  },
  {
    id: 'KEY_ATTRIBUTES',
    label: 'Exceptions configuration',
    tableName: ['KEY_ATTRIBUTES_HEADER', 'KEY_ATTRIBUTES_LIST'],
    description: 'Exception handling rules and configurations',
    mandatory: false
  },
  {
    id: 'PRODUCTS',
    label: 'Products to track feature classification',
    tableName: ['PRODUCTS_BY_PROJECT', 'PRODUCTS_BY_PROJECT_USER_ACCESS'],
    description: 'Product tracking and user access settings',
    mandatory: false
  },
  {
    id: 'USER_PROJECTS',
    label: 'Project level users access',
    tableName: 'USER_PROJECTS',
    description: 'User permissions and project access',
    mandatory: false
  }
];

export const getAllTableNames = () => {
  const allTables = [];
  COPY_OPTIONS.forEach(option => {
    if (Array.isArray(option.tableName)) {
      allTables.push(...option.tableName);
    } else {
      allTables.push(option.tableName);
    }
  });
  return allTables;
};